import { useNavigate } from "react-router-dom";
import { useReleaselicenseMutation } from "../../../redux/api/BaseApi";
import { Spinny } from "../Spinny";

const Logout = () => {
  const navigate = useNavigate();
  const logMeOut = async (params: any) => {
    navigate('/signout');
  };

  return (
    <>
      <button
        className="bg-[#d44133] grid place-content-center h-[30px] w-[30px]"
        onClick={logMeOut}
      >
        <img
          title="Logout"
          src={"./images/logout.png"}
          alt="signout button"
        />
      </button>
    </>
  );
};

export default Logout;
